import {
  FC,
  JSXElementConstructor,
  ReactElement,
  ReactPortal
} from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@mui/styles';

// Contexts
import { withTenant, withTranslate } from '../../../core/TenantProvider';
// Components - Atoms, Molecules, Organisms, Pages
import APBackdropLoader from '../../../components/atoms/APBackdropLoader';
import APSlidingMenu from '../APSlidingMenu';
import APHeader from '../APHeader';
import ScrollToTop from '../../../router/ScrollToTop';
import APFooter from '../APFooter';
import APSlidingRightPanelContainer from '../../../containers/APSlidingRightPanelContainer';
// Validation Schema or files in the same folder
import MainStyles from './styles/index.style';
// Redux
import { ReducerState } from '../../../redux/modules';

export type ComponentChildrenType =
  | string
  | number
  | boolean
  | ReactElement<any, string | JSXElementConstructor<any>>
  | ReactPortal
  | null
  | undefined;

export interface APLayoutProps extends WithStyles<typeof MainStyles> {
  affiliateDetails: any,
  isAuthenticated: boolean | null,
  authLoadingState: string,
  affiliateLoadingState: string,
  children: ComponentChildrenType;
}


const APLayout: FC<APLayoutProps> = (props: APLayoutProps) => {
  const { classes, affiliateDetails, isAuthenticated, affiliateLoadingState } = props;

  return (
    <div className={classes.application}>
      {isAuthenticated && (
        <div className={classes.left}>
          <APSlidingMenu affiliateDetails={affiliateDetails} />
        </div>
      )}
      <div className={classes.right}>
        <APHeader />
        <ScrollToTop>
          <div className={classes.applicationContent}>
            {affiliateLoadingState === 'LOADING' ? <APBackdropLoader open={true} /> : props.children}
          </div>
        </ScrollToTop>
        <APFooter />
      </div>
      {isAuthenticated && (
        <div>
          <APSlidingRightPanelContainer />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (store: ReducerState) => ({
  isAuthenticated: store.user.isAuthenticated,
  authLoadingState: store.user.loadingState,
  affiliateDetails: store.user.affiliateDetails,
  affiliateLoadingState: store.user.affiliateLoadingState,
  roleAccessFunction: store.user.roleAccessFunction,
  launchDarklyFlags: store.user.launchDarklyFlags
});

export default withTenant(
  withTranslate(
    connect(mapStateToProps)(
      withStyles(MainStyles)(APLayout)
    )
  )
);
